<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش اعتبارسنجی ایران" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="3">
						</v-col>
						<v-col cols="12" md="6">
							<date-navigator v-model="dateRange" :options="{ rangeMode: true, defaultEmpty: true }">
								<div class="text-center">
									<v-btn color="primary" dark class="mx-1" @click="loadData">
										دریافت اطلاعات
									</v-btn>
								</div>
							</date-navigator>
						</v-col>
						<v-col cols="12" md="3" class="d-flex align-center justify-end">
							<export-excel :items="items" :headers="headers" :fileName="excelFileName">
							</export-excel>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="items" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="50" :search="search" class="elevation-1">
								<template v-slot:item="row">
									<tr>
										<td>
											<div @click="manageLoans(row.item.member)" style="cursor:pointer">
												<div>{{ row.item.member.fullName }}</div>
												<div>{{ row.item.member.mobile }}</div>
											</div>
										</td>
										<td class="text-center">
											&lrm;{{ row.item.date_Persian.date }} {{ row.item.date_Persian.time }}
										</td>
										<td class="text-center">
											{{ row.item.price.toString().toPriceFormat() }}
										</td>
										<td class="text-center">
											{{ row.item.status_Str }}
										</td>
										<td class="text-center">
											{{ row.item.messages }}
										</td>
										<td class="text-center">
											{{ row.item.result }}
										</td>
										<td class="text-center">
											{{ row.item.gradeNumber }}
										</td>
										<td class="text-center">
											<a v-if="row.item.url" :href="row.item.url" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">مشاهده</a>
											<div v-else>-</div>
										</td>
										<td class="text-center">
											<a v-if="row.item.reportPdfFileName" :href="`/IranValidity/DownloadPdf/${row.item.id}`" target="_blank" style="text-decoration: none;font-size: 11px;" class="secondary--text link">دانلود</a>
											<div v-else>-</div>
										</td>
									</tr>
								</template>
							</v-data-table>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
		<v-dialog v-model="dialogLoansManager" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">مدیریت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogLoansManager = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<manage-loan ref="manageLoan" :data="{ member: selectedMember }" />
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'SponsoredLoans',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'date-navigator': () => import('@/components/DateNavigator'),
			'loans': () => import('./SponsoredUserLoans'),
			'manage-loan': () => import('@/views/admin/ManageLoan.vue'),
			'sponsored-paids': () => import('./SponsoredPaids'),
			'date-picker': VuePersianDatetimePicker,
		},
		data() {
			return {
				dialogLoansManager: false,
				selectedMember: {},
				startDateValidatioin: '',
				endDateValidatioin: '',
				loadedReport_startDate: '',
				loadedReport_endDate: '',
				search: '',
				loading: false,
				headers: [
					{
						text: 'مشتری',
						align: 'start',
						sortable: true,
						value: 'member',
						width: '150'
					}, {
						text: 'تاریخ',
						align: 'center',
						sortable: true,
						value: 'date_Persian',
						width: '100'
					}, {
						text: 'هزینه',
						align: 'center',
						sortable: true,
						value: 'price',
					}, {
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'status_Str',
					}, {
						text: 'پیام',
						align: 'center',
						sortable: true,
						value: 'messages',
					}, {
						text: 'رتبه',
						align: 'center',
						sortable: true,
						value: 'result',
					}, {
						text: 'اعتبار',
						align: 'center',
						sortable: true,
						value: 'gradeNumber',
					}, {
						text: 'لینک گزارش',
						align: 'center',
						sortable: true,
						value: 'url',
					}, {
						text: 'دریافت pdf',
						align: 'center',
						sortable: true,
						value: 'reportPdfFileName',
					},
				],
				items: [],
				dateRange: { start: '', end: '' }
			}
		},
		computed: {
			excelFileName() {
				let name = 'گزارش تجمیعی وام های اسپانسری'
				if (this.dateRange.start)
					name += ' از ' + this.dateRange.start.toString().split('T')[0]
				if (this.dateRange.end)
					name += ' تا ' + this.dateRange.end.toString().split('T')[0]
				name += '.xls'
				return name
			}
		},
		mounted() {
		},
		methods: {
			manageLoans(item) {
				this.selectedMember = { id: item.id, fullName: item.fullName, nationalCode: item.nationalCode, mobile: item.mobile, userName: item.userName }
				this.dialogLoansManager = true
				this.$nextTick(() => {
					this.$refs.manageLoan.loadData()
				})
			},
			loadData() {
				this.loading = true
				api.get('admin/IranValidityReport/List/?start=' + this.dateRange.start + '&end=' + this.dateRange.end, {})
					.then(
						response => {
							this.items = response
							this.loadedReport_startDate = this.dateRange.start
							this.loadedReport_endDate = this.dateRange.end
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style></style>
